const createCookie = (cname: string, cvalue: string, exdays?: number) => {
  const expDaysInNumber = exdays || 1000;
  const date = new Date();
  date.setTime(date.getTime() + expDaysInNumber * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${cname}=${cvalue}; ${expires}; path=/`;
};

const getCookie = (name: string): undefined | string => {
  const cookieArr = document.cookie.split(';');
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=');
    if (name === cookiePair[0].trim()) {
      try {
        return decodeURIComponent(cookiePair[1]);
      } catch (error) {
        console.log('error while decoding', error);
      }
    }
  }
  return undefined;
};

export { createCookie, getCookie };
